import { MockRestCall } from "@/common/api/ApiResult.model";
import { RestCallsKey } from "../demo/rest.resolver";
import { MockUsers } from "@/views/customize/in-motion/exposure-control/data/users.mock";
import { create_carousel, uniq_id } from "./utils";
import { POPULATION_TYPE } from "@/common/models";
import {
  FamiliarityEntityType,
  FamiliarityLevel,
  FamiliarityLevelColors,
  FamiliarityStatus,
} from "@/views/customize/in-motion/exposure-control/data/models";
import { memoize, percentage, singleton, to_chunks } from "@/fp";

//@ts-ignore
window.to_chunks = to_chunks;

const MockUsersCarousel = create_carousel(4, MockUsers);
const DepartmentsCarousel = singleton<void, Promise<{ next: () => any[] }>>(
  async () => {
    const { SharedState } = await import("@/common/state");
    const id_name_arr = Object.entries(SharedState.departments.value).map(
      ([id, name]) => {
        return {
          id,
          name,
        };
      }
    );
    const carousel = create_carousel(
      2,
      to_chunks(id_name_arr.length / 2)(id_name_arr)
    );
    return carousel;
  }
);

const get_affinity = percentage(25);

const counters = {
  unmanaged: Array(8)
    .fill({})
    .map(() => Math.floor(Math.random() * 15) + 1),
  trusted: Array(8)
    .fill({})
    .map(() => Math.floor(Math.random() * 15) + 1),
  untrusted: Array(8)
    .fill({})
    .map(() => Math.floor(Math.random() * 15) + 1),
};

// @ts-ignore
export const manage_exposure: Record<Partial<RestCallsKey>, MockRestCall> = {
  "familiarity-counters": {
    delay: 1000,
    payload: async () => {
      const { SharedState } = await import("@/common/state");
      const l0s = (type: string) =>
        SharedState.l0InfoTypes.value.map((l) => ({
          id: l.id,
          // @ts-ignore
          count: counters[type][l.code],
        }));
      return {
        unmanaged: l0s("unmanaged"),
        trusted: l0s("trusted"),
        untrusted: l0s("untrusted"),
      };
    },
  },
  "familiarity-get-entities-for-status": {
    payload: memoize(
      async (p: {
        status: FamiliarityStatus;
        entity_type: FamiliarityEntityType;
        label_id: string;
      }) => {
        const { SharedState } = await import("@/common/state");
        const l0_id = SharedState.getInfoType(p.label_id).parentId!;
        const { code } = SharedState.allInfoTypes.value[l0_id];
        // @ts-ignore
        const users_count = counters[p.status][code] || 0;
        if (p.entity_type === POPULATION_TYPE.DEPARTMENT) {
          const get_level = {
            trusted: "strong",
            untrusted: "new",
            unmanaged: "none",
          };

          const deps = await DepartmentsCarousel();
          const current_deps = deps.next();
          console.log("current_deps : ", current_deps);
          return {
            cursor: "",
            count: users_count,
            objects: current_deps.slice(0, users_count).map(({ id, name }) => {
              // @ts-ignore
              const level = get_level[p.status] as FamiliarityLevel;
              return {
                id: id,
                entityId: id,
                name: name,
                labelId: p.label_id,
                status: p.status,
                level,
                level_color: FamiliarityLevelColors[level as FamiliarityLevel],
              };
            }), // "2021-08-19T08:53:35.000Z"
          };
        } else {
          return {
            cursor: "",
            count: users_count,
            objects: MockUsersCarousel.next()
              .slice(0, users_count)
              .map((email) => {
                return {
                  entityId: email,
                  email: email,
                  firstEventAt: "2021-08-19T08:53:35.000Z",
                  lastEventAt: "2021-08-19T08:53:35.000Z",
                  eventCount: 10,
                  addedAt: "2021-08-19T08:53:35.000Z",
                  affinity: get_affinity(Math.floor(Math.random() * 25)),
                };
              }),
          };
        }
      }
    ),
  },
  /* 
  "familiarity-update-entity-status": {
    payload: () => {
      //
    },
  },
  "familiarity-get-entity-status": {
    payload: (payload: {
      entityId: string;
      labelIds: string[];
      type: POPULATION_TYPE;
    }) => {
      const get_affinity_from_score = percentage(25);
      return payload.labelIds.map((id: any) => {
        return {
          labelId: id,
          entityId: payload.entityId,
          affinity: get_affinity_from_score(10),
          status: "trusted" as FamiliarityStatus,
        };
      });
    },
  }, */
};
